export class DlTableRow {
    key: any = "";
    value: any = "";
    valueIsHtml: boolean = false;
}
